"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const useOutsideClick = (ref, callback) => {
    const handleClick = React.useCallback(event => {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !(ref === null || ref === void 0 ? void 0 : ref.current.contains(event.target))) {
            callback();
        }
    }, [callback, ref]);
    React.useEffect(() => {
        setTimeout(() => {
            document.addEventListener('click', handleClick);
        }, 0);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [ref, callback, handleClick]);
};
exports.default = useOutsideClick;
